import React from 'react';
import classNames from 'classnames';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import Alert from '@johnlewispartnership/wtr-ingredients/dist/Alert';
import { summaryBoxShape } from '../../../../constants/data-shapes/competitions-form';
import styles from './index.module.scss';
import commonStyles from '../../CompetitionsForm.module.scss';
const prettyNames = {
    competitionAnswer: 'answer',
    answer: 'answer',
    purchaseType: 'purchase type',
    fullName: 'full name',
    email: 'email',
    addressLine1: 'address',
    addressLine2: 'address (line 2)',
    addressLine3: 'address (line 3)',
    postalCode: 'postcode',
    termsAndConditions: 'terms and conditions',
    onlineOrderNumber: 'order number',
    receiptNumber: 'receipt number',
    title: 'title',
};
const orderOfFields = [
    'competitionAnswer',
    'answer',
    'purchaseType',
    'onlineOrderNumber',
    'receiptNumber',
    'title',
    'fullName',
    'email',
    'addressLine1',
    'addressLine2',
    'addressLine3',
    'postalCode',
    'termsAndConditions',
];
const SummaryBox = ({ errorsCount, errors }) => {
    var _a;
    if (!errorsCount || ((_a = errors === null || errors === void 0 ? void 0 : errors.email) === null || _a === void 0 ? void 0 : _a.type) === 'duplicate-entry')
        return null;
    return (React.createElement("div", { "data-testid": "summaryBox", className: classNames(commonStyles.sectionWrapper, commonStyles.spacer) },
        React.createElement(Alert, { title: errorsCount > 1
                ? `The following ${errorsCount} items require your attention`
                : `The following item requires your attention`, type: "error", message: React.createElement("ol", { className: styles.errorsList }, orderOfFields.map(field => {
                const error = errors[field];
                if (!error)
                    return null;
                return (React.createElement("li", { key: field },
                    "Please provide your",
                    ' ',
                    React.createElement(TextLink, { component: "button", id: `scrollToButton-${field}`, onClick: () => {
                            if (error.ref.scrollIntoView) {
                                error.ref.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                error.ref.focus({ preventScroll: true });
                            }
                        }, type: "button" }, prettyNames[field])));
            })) })));
};
export default SummaryBox;
SummaryBox.propTypes = summaryBoxShape;
//# sourceMappingURL=SummaryBox.js.map